import { render, staticRenderFns } from "./GoodsListAdmin.vue?vue&type=template&id=77ca884e&scoped=true"
import script from "./GoodsListAdmin.vue?vue&type=script&lang=js"
export * from "./GoodsListAdmin.vue?vue&type=script&lang=js"
import style0 from "./GoodsListAdmin.vue?vue&type=style&index=0&id=77ca884e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ca884e",
  null
  
)

export default component.exports